import { OrgSeatTable } from "./licenses";

export function DevicesPage() {
  return (
    <OrgSeatTable
      tab="devices"
      title="Devices"
      description="Devices belong to an organisation. Pick one to see its activated devices and revoke access."
    />
  );
}
